import React, { useEffect, useState } from "react";
import Timer from "../Timer/Timer";
import { useRedebanStore } from "../../store/useRedebanStore";
import loading from "../../assets/images/loading.svg";
import pay from "../../assets/images/pay.svg";
import success from "../../assets/images/pay-success.svg";
import error from "../../assets/images/pay-error.svg";
import print from "../../assets/images/print.svg";
import "./payStatus.css";

const PayStatus = () => {
  const startTimer = useRedebanStore((state) => state.startTimer);
  const currentExplanation = useRedebanStore(
    (state) => state.currentExplanation
  );
  const { explanations } = useRedebanStore.getState();
  const [explanation, setExplanation] = useState(null);

  useEffect(() => {
    if (currentExplanation) {
      const explanation = explanations.find(
        (explanation) => explanation.id === currentExplanation
      );
      setExplanation(explanation);
    } else {
      setExplanation(null);
    }
  }, [currentExplanation]);

  return (
    <div className="payStatus">
      <div className="payStatus-content">
        {startTimer && (
          <Timer label="Tiempo restante para completar tu compra" endTime={3} />
        )}
        {explanation && (
          <>
            {explanation.id === 1 && (
              <img
                className="payStatus-loading"
                src={loading}
                alt="Cargando..."
              />
            )}
            {explanation.image === "pay" && (
              <img className="payStatus-img" src={pay} alt="Comprobando..." />
            )}
            {explanation.image === "success" && (
              <img
                className="payStatus-img"
                src={success}
                alt="Compra exitosa..."
              />
            )}
            {explanation.image === "error" && (
              <img
                className="payStatus-img"
                src={error}
                alt="Compra fallida..."
              />
            )}
            {explanation.image === "print" && (
              <img className="payStatus-img" src={print} alt="Imprimiendo..." />
            )}
            <div
              className="payStatus-content"
              dangerouslySetInnerHTML={{ __html: explanation.content }}
            />
            {explanation.end && (
              <button
                className="payStatus-button"
                onClick={() => {
                  window.location.href = "/banners";
                }}
              >
                Finalizar compra
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PayStatus;
